module.exports = __webpack_public_path__ + "264b4cccac03a943d53e79217d0a1e09.png";